import {DocumentGroup} from '@/engine';

export const getAllFields = (group: DocumentGroup) => {
  if ('type' in group) {
    switch (group.type) {
      case 'array':
        return group.rows.flatMap(row => row.fields);
      default:
        throw new Error(`Unsupported group type: ${group.type}`);
    }
  }
  return group.fields;
};

export const getVisibility = (group: DocumentGroup) => {
  if ('type' in group) {
    switch (group.type) {
      case 'array':
        return group.rows.some(row => row.visible);
      default:
        throw new Error(`Unsupported group type: ${group.type}`);
    }
  }
  return group.visible;
};
